import SignedPutUrlFileUpload, {
  SignedPutUrlFileUploadOptions,
} from "./SignedPutUrlFileUpload";
import makeGetSignedPutUrlForBrand from "./signedPutUrlForBrand";

type SignedPutUrlForBrandFileUploadOptions = SignedPutUrlFileUploadOptions & {
  brandId: UUID;
};

export default class SignedPutUrlForBrandFileUpload extends SignedPutUrlFileUpload {
  public brandId: UUID;

  constructor({ brandId, ...rest }: SignedPutUrlForBrandFileUploadOptions) {
    super(rest);
    this.brandId = brandId;
    this.getSignedPutUrl = makeGetSignedPutUrlForBrand(
      rest.apolloClient,
      brandId,
    );
  }

  getSentryExtra() {
    const base = super.getSentryExtra();
    return {
      ...base,
      brandId: this.brandId,
    };
  }
}
